import React from "react";
import { Route } from "react-router";
import NoBrandPageRoute from "../containers/NoBrandPageRoute";
import SearchPageRoute from "../containers/SearchPageRoute";
import BrandsPageRoute from "../containers/BrandsPageRoute";
import NotFoundErrorPageRoute from "../containers/NotFoundErrorPageRoute";
import CategoryPageRoute from "../containers/CategoryPageRoute";
import {
  BRAND_ERROR,
  SEARCH_PAGE,
  BRANDS_PAGE,
  CATEGORY_PAGE,
  PAGE_NOT_FOUND
} from "../state/modules/page/constants";
import {
  BRAND_ERROR_PATH_MATCHER,
  BRAND_UNAVAILABLE_PATH_MATCHER,
  SEARCH_PAGE_PATH_MATCHER,
  BRANDS_PAGE_PATH_MATCHER,
  CATEGORY_PAGE_PATH_MATCHER,
  PAGE_NOT_FOUND_PATH_MATCHER
} from "./constants";

const routes = [
  <Route
    path={BRAND_ERROR_PATH_MATCHER}
    pageName={BRAND_ERROR}
    component={NoBrandPageRoute}
    key={1}
  />,
  <Route
    path={BRAND_UNAVAILABLE_PATH_MATCHER}
    pageName={BRAND_ERROR}
    component={NoBrandPageRoute}
    key={2}
  />,
  <Route
    path={SEARCH_PAGE_PATH_MATCHER}
    pageName={SEARCH_PAGE}
    component={SearchPageRoute}
    key={3}
  />,
  <Route
    path={BRANDS_PAGE_PATH_MATCHER}
    pageName={BRANDS_PAGE}
    component={BrandsPageRoute}
    key={4}
  />,
  <Route
    path={CATEGORY_PAGE_PATH_MATCHER}
    pageName={CATEGORY_PAGE}
    component={CategoryPageRoute}
    key={5}
  />,
  // This is a catch-all for any requests that make their way to us, but we don't know how to handle.
  <Route
    path={PAGE_NOT_FOUND_PATH_MATCHER}
    pageName={PAGE_NOT_FOUND}
    component={NotFoundErrorPageRoute}
    key={99}
  />
];

export default routes;
